module.exports = __webpack_public_path__ + "img/dzdt-img.2504285b.png";